import { useAppDispatch } from "@sso/hooks/useRedux";
import { closeDialog } from "@sso/store/slices/dialog";
import { Button } from "@sso/ui/Button";
import { RowContainer, Wrapper } from "@sso/ui/FlexBox";
import { LinearLoading } from "@sso/ui/LinearLoading";

interface DialogActionButtonsProps {
  buttonTitle: string;
  buttonType?: "submit" | "button";
  loading?: boolean;
  onClickAction?: () => void;
  onClickCancel?: () => void;
}

export const DialogActionButtons = ({
  buttonTitle,
  loading,
  buttonType,
  onClickAction,
  onClickCancel,
}: DialogActionButtonsProps) => {
  const dispatch = useAppDispatch();

  const handleCloseDialog = () => {
    dispatch(closeDialog());
    onClickCancel && onClickCancel();
  };

  return (
    <RowContainer position="relative" width="100%" padding="0.5rem 0" justify="flex-end">
      <Button variant="text" padding="0.5rem" disabled={loading} onClick={handleCloseDialog}>
        Cancel
      </Button>
      <Button
        variant="text"
        padding="0.5rem"
        margin="0.2rem 1rem 0.2rem 0.2rem"
        disabled={loading}
        type={buttonType || "submit"}
        onClick={onClickAction}
      >
        {buttonTitle}
      </Button>
      {loading && (
        <Wrapper position="absolute" bottom="0" width="100%">
          <LinearLoading />
        </Wrapper>
      )}
    </RowContainer>
  );
};
